var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('v-img',{staticClass:"title",attrs:{"src":require("@/assets/images/title_lsf16_atlantis.png"),"max-width":"70vw","contain":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }